import NavUser from "./nav_user";
import Box from "@mui/material/Box";

export default function NavToolbarActions() {

    return (
        <Box display='flex' alignItems='center'>            
            <NavUser />
        </Box>
    );
}

